import React, { createContext, useCallback, useMemo, useState } from "react";
import { SweetAlertProvider } from "./sweet_alert.js";
import Loading from "./loading.js";

export const AppContext = createContext();

const readStoredJSON = (key) => {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

const writeStoredJSON = (key, value) => {
  if (typeof window === "undefined") return;
  if (value === null || value === undefined) {
    window.localStorage.removeItem(key);
  } else {
    window.localStorage.setItem(key, JSON.stringify(value));
  }
};

export const AppProvider = ({ children }) => {
  const [loadingState, setLoadingState] = useState({ active: false, message: null });
  const [mOpen, setMOpen] = useState(true);
  const [pageSelect, setPageSelect] = useState("Dashboard");
  const [userState, setUserState] = useState(() => readStoredJSON("user"));
  const [businessState, setBusinessState] = useState(() => readStoredJSON("business"));
  const [entitlementsState, setEntitlementsState] = useState(null);
  const [planState, setPlanState] = useState(null);

  const showLoading = useCallback(
    (message = null) => setLoadingState({ active: true, message }),
    []
  );

  const hideLoading = useCallback(
    () => setLoadingState({ active: false, message: null }),
    []
  );

  const abreFechaMenu = useCallback(() => setMOpen((prev) => !prev), []);
  const fechaMenu = useCallback(() => setMOpen(false), []);

  const selecionaPagina = useCallback((pagina) => setPageSelect(pagina), []);

  const setUser = useCallback((value) => {
    const sanitized = value || null;
    setUserState(sanitized);
    writeStoredJSON("user", sanitized);
  }, []);

  const setBusiness = useCallback((value) => {
    const sanitized = value || null;
    setBusinessState(sanitized);
    writeStoredJSON("business", sanitized);
  }, []);

  const setEntitlements = useCallback((value) => {
    setEntitlementsState(value || null);
  }, []);

  const setPlan = useCallback((value) => {
    setPlanState(value || null);
  }, []);

  const contextValue = useMemo(
    () => ({
      loading: loadingState,
      mOpen,
      pageSelect,
      user: userState,
      setUser,
      business: businessState,
      setBusiness,
      entitlements: entitlementsState,
      setEntitlements,
      plan: planState,
      setPlan,
      showLoading,
      hideLoading,
      abreFechaMenu,
      fechaMenu,
      selecionaPagina,
    }),
    [
      loadingState,
      mOpen,
      pageSelect,
      userState,
      setUser,
      businessState,
      setBusiness,
      entitlementsState,
      setEntitlements,
      planState,
      setPlan,
      showLoading,
      hideLoading,
      abreFechaMenu,
      fechaMenu,
      selecionaPagina,
    ]
  );

  return (
    <SweetAlertProvider>
      <AppContext.Provider value={contextValue}>
        {children}
        <Loading />
      </AppContext.Provider>
    </SweetAlertProvider>
  );
};
